import { IconComponent } from 'models/icons';

/**
 * @deprecated This component has following errors from generation:
 *
 * **ERROR: assets/icons/handler.svg has a stroke color. Please outline strokes in figma before exporting it to svg.**
 *
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/handler.svg
 */
const IconHandler: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M12.059 22.55c.06.01.122.015.184.017.062-.002.125-.008.186-.018.06 0 .117-.018.174-.034.06-.02.117-.044.173-.075a1.12 1.12 0 00.112-.046l7.816-5.08a.603.603 0 00.088-1.02 1.228 1.228 0 00-1.379-.068l-7.17 4.664-7.169-4.664a1.228 1.228 0 00-1.379.067.63.63 0 00-.24.477.663.663 0 00.33.544l7.812 5.08c.037.017.074.033.112.047.056.029.113.053.173.074.057.034.112.034.177.034zM12.43 1.45a1.525 1.525 0 00-.185-.017 1.542 1.542 0 00-.187.018.887.887 0 00-.347.109c-.036.018-.078.026-.111.046l-7.814 5.08a.603.603 0 00-.09 1.021 1.227 1.227 0 001.378.064l7.171-4.664 7.168 4.664a1.228 1.228 0 001.379-.064.623.623 0 00.24-.477.66.66 0 00-.33-.544l-7.812-5.08c-.033-.02-.075-.028-.112-.046a1.046 1.046 0 00-.173-.075 1.349 1.349 0 00-.176-.034z"
      fill="currentColor"
    />
    <path
      d="M1 12.082h22"
      stroke="currentColor"
      strokeWidth={0.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconHandler;
